import jwtDecode from 'jwt-decode'
import { InternalAxiosRequestConfig } from 'axios'

import { useEditorStore } from '../../store/useEditorStore'
import { getEditorToken } from '../../api/editor/editor'
import { EditorTokenPayload } from '../../types/editor'

export function editorTokenInterceptor() {
  return async (
    config: InternalAxiosRequestConfig
  ): Promise<InternalAxiosRequestConfig> => {
    const editorStore = useEditorStore.getState()
    const editorData = editorStore.editorData

    // skip editor token addition on api calls happening outside editor context
    if (editorData === null) return config
    // skip token check when explicitly set in axios params
    // to be used in cases where token is generated by the calling api
    if (config.params?.skipTokenCheck) return config

    // check token expiry & refetch if required
    const tokenPayload = jwtDecode<EditorTokenPayload>(editorData.editorToken)
    if (isTokenExpired(tokenPayload.exp)) {
      console.info('token expired, fetching new token...')
      const newEditorToken = await getEditorToken({
        documentId: editorData.docId,
        itemId: editorData.itemId,
        itemType: editorData.itemType
      })
      editorStore.setEditorData({ ...editorData, editorToken: newEditorToken })
      config.headers['x-editor-token'] = newEditorToken
    } else {
      config.headers['x-editor-token'] = editorData.editorToken
    }

    return config
  }
}

function isTokenExpired(expiresAt: number): boolean {
  const now = Date.now()
  const bufferTime = 5 * 60 * 1000 // 5 mins
  const expiresAtMs = expiresAt * 1000
  return now >= expiresAtMs - bufferTime
}
